








































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import moment from 'moment'
import { removeAdmin } from '@/apps/open/services/admin'
import Avatar from '@/apps/open/components/Avatar'
import TransferSuperAdminMixin from '@/apps/open/mixins/TransferSuperAdmin'
import { onRequestError } from '@/apps/open/utils'
import DepartmentDialog from '@/apps/open/components/DialogBodys/DepartmentDialog/index.js'

@Component({
  components: {
    Avatar,
    DepartmentDialog
  },
  data: () => ({
    moment
  })
})
export default class List extends Mixins(TransferSuperAdminMixin) {
  selectedMembers: any[] = []

  @Prop()
  data: any

  @Prop()
  isSuperAdmin: any

  @Prop()
  disabledAccountIDs!: number[]

  showRemoveDialog (row: any) {
    this.$dialog.show({
      title: '移除成员',
      width: '400px',
      body: `<div style="line-height: 24px">确定移除 ${row.username} 吗？<br>移除的管理员将不能进行应用开发等操作</div>`,
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', fn: () => { this.onRemoveMember(row) } }
      ]
    })
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  async onRemoveMember (user: any) {
    try {
      await removeAdmin(user.userid, this.curEnterprise.developer_id)
      this.$dialog.close()
      this.$emit('onRemoveUser', user.userid)
    } catch (error) {
      onRequestError(error)
    }
  }

  // transfer admin in private environment
  handleTransferAdmin (users: any) {
    this.transfer(users[0])
  }
}
